'use strict';

import CmsModel from 'standard-vote/app/scripts/models/cms.js';

module.exports = CmsModel;



// WEBPACK FOOTER //
// ./app/scripts/models/cms.js